import { render, staticRenderFns } from "./Loading4.vue?vue&type=template&id=221629a2&scoped=true"
import script from "./Loading4.vue?vue&type=script&lang=js"
export * from "./Loading4.vue?vue&type=script&lang=js"
import style0 from "./Loading4.vue?vue&type=style&index=0&id=221629a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221629a2",
  null
  
)

export default component.exports